module.exports = __webpack_public_path__ + "static/img/doctor.67de1d70.png";